// extracted by mini-css-extract-plugin
module.exports = {"container":"botprofiledialog_container__w2JSO","name":"botprofiledialog_name__d1brQ","avatar":"botprofiledialog_avatar__H0UCe"};